/**
 * generateSafeRegex — verbatim from v1 everything_else.js (research/04 §2.4;
 * REQ-FORM-7; research/01 Q11). Escapes exactly ( ) [ ] ? / + $ € £ ¥ " ' —
 * and does NOT escape . * - ^ | { } \ .
 *
 * (getCurrentElementDataByIdenfier moved to formula/lookup-tables.ts in the
 * Phase-4 split.)
 */
export function generateSafeRegex(identifier: any): RegExp {
  let identifierForFormula = identifier.toLowerCase();
  identifierForFormula = identifierForFormula.replace(/\(/g, "\\("); // (
  identifierForFormula = identifierForFormula.replace(/\)/g, "\\)"); // )
  identifierForFormula = identifierForFormula.replace(/\[/g, "\\["); // [
  identifierForFormula = identifierForFormula.replace(/\]/g, "\\]"); // ]
  identifierForFormula = identifierForFormula.replace(/\?/g, "\\?"); // ?
  identifierForFormula = identifierForFormula.replace(/\//g, "\\/"); // /
  identifierForFormula = identifierForFormula.replace(/\+/g, "\\+"); // +
  identifierForFormula = identifierForFormula.replace(/\$/g, "\\$"); // $
  identifierForFormula = identifierForFormula.replace(/\€/g, "\\€"); // €
  identifierForFormula = identifierForFormula.replace(/\£/g, "\\£"); // £
  identifierForFormula = identifierForFormula.replace(/\¥/g, "\\¥"); // ¥
  identifierForFormula = identifierForFormula.replace(/\"/g, '\\"'); // "
  identifierForFormula = identifierForFormula.replace(/\'/g, "\\'"); // '

  var regexPattern = new RegExp(identifierForFormula, "g");
  return regexPattern;
}
